module.exports = __webpack_public_path__ + "static/media/suny.75754e51.png";